import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/urgent-now.jpeg";

function HvorforHasterDetNa() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.urgentNow.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.urgentNow.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/hvorfor-haster-det-na"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.urgentNow.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.urgentNow.description")}
          </p>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.urgentNow.description2")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.urgentNow.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5">
          <img
            src={article_img}
            className="w-full"
            alt={i18next.t("pages.articles.list.urgentNow.imageAlt")}
          />
          <p className="text-sm text-secondary mt-2">
            {i18next.t("pages.articles.credit.photoBy")}{" "}
            <a
              href="https://nor01.safelinks.protection.outlook.com/?url=https%3A%2F%2Funsplash.com%2F%40jakubzerdzicki%3Futm_source%3Dunsplash%26utm_medium%3Dreferral%26utm_content%3DcreditCopyText&data=05%7C02%7Cj.ugland%40xperconsulting.no%7C2699bba86598485f508c08de3c874f1d%7C6051a23802de4cb0a8c56136b6c8c676%7C0%7C0%7C639014749167103752%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=mwky8bWyEBiMFW%2FKxHpH%2Bn%2Fbjpi6H92et4asguBQ%2BQc%3D&reserved=0"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Jakub Żerdzicki
            </a>{" "}
            {i18next.t("pages.articles.credit.on")}{" "}
            <a
              href="https://nor01.safelinks.protection.outlook.com/?url=https%3A%2F%2Funsplash.com%2Fphotos%2Fa-laptop-computer-sitting-on-top-of-a-white-desk--F1gB8VGrS8%3Futm_source%3Dunsplash%26utm_medium%3Dreferral%26utm_content%3DcreditCopyText&data=05%7C02%7Cj.ugland%40xperconsulting.no%7C2699bba86598485f508c08de3c874f1d%7C6051a23802de4cb0a8c56136b6c8c676%7C0%7C0%7C639014749167154898%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=Tdo2olSxftqiAMAPiJYiWkRD1%2BRZPW0jMrd%2FU1DGmwo%3D&reserved=0"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Unsplash
            </a>
          </p>
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <h2 className="text-3xl font-bold mb-2">
              {i18next.t("pages.articles.list.urgentNow.sections.whyNow.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.urgentNow.sections.whyNow.content")}
            </p>
            <p className="mb-2">
              {i18next.t("pages.articles.list.urgentNow.sections.whyNow.content2")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.urgentNow.sections.biggestChallenge.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.urgentNow.sections.biggestChallenge.content")}
            </p>
            <p className="mb-2">
              {i18next.t("pages.articles.list.urgentNow.sections.biggestChallenge.waitIntro")}
            </p>
            <ul className="list-disc list-outside ml-6">
              <li>{i18next.t("pages.articles.list.urgentNow.sections.biggestChallenge.points.1")}</li>
              <li>{i18next.t("pages.articles.list.urgentNow.sections.biggestChallenge.points.2")}</li>
              <li>{i18next.t("pages.articles.list.urgentNow.sections.biggestChallenge.points.3")}</li>
            </ul>
            <p className="mt-2">
              {i18next.t("pages.articles.list.urgentNow.sections.biggestChallenge.conclusion")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.urgentNow.sections.howTo.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.urgentNow.sections.howTo.intro")}
            </p>
            <ol className="list-decimal list-outside ml-6">
              <li className="mb-1">
                <b>{i18next.t("pages.articles.list.urgentNow.sections.howTo.steps.1.title")}</b>{" "}
                {i18next.t("pages.articles.list.urgentNow.sections.howTo.steps.1.content")}
              </li>
              <li className="mb-1">
                <b>{i18next.t("pages.articles.list.urgentNow.sections.howTo.steps.2.title")}</b>{" "}
                {i18next.t("pages.articles.list.urgentNow.sections.howTo.steps.2.content")}
              </li>
              <li className="mb-1">
                <b>{i18next.t("pages.articles.list.urgentNow.sections.howTo.steps.3.title")}</b>{" "}
                {i18next.t("pages.articles.list.urgentNow.sections.howTo.steps.3.content")}
              </li>
              <li className="mb-1">
                <b>{i18next.t("pages.articles.list.urgentNow.sections.howTo.steps.4.title")}</b>{" "}
                {i18next.t("pages.articles.list.urgentNow.sections.howTo.steps.4.content")}
              </li>
              <li>
                <b>{i18next.t("pages.articles.list.urgentNow.sections.howTo.steps.5.title")}</b>{" "}
                {i18next.t("pages.articles.list.urgentNow.sections.howTo.steps.5.content")}
              </li>
            </ol>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.urgentNow.sections.onDemand.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.urgentNow.sections.onDemand.content")}
            </p>

            <p className="mt-6">
              {i18next.t("pages.articles.list.urgentNow.sections.cta.content")}{" "}
              <a href="/skjema/kontakt-oss" className="font-bold underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.urgentNow.sections.cta.link")}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HvorforHasterDetNa;



